import { isGifAttachment, type FileMessageContent } from "@fitness-app/data-models/entities/Chat";

/** Channel-list preview for a message with no text (TRE-2104: GIFs get their own label). */
export const getAttachmentPreview = (files?: FileMessageContent[] | null): string => {
  if (files?.length === 1 && isGifAttachment(files[0])) {
    return "Przesłano GIF-a";
  }
  return "Przesłano załącznik";
};
